import * as IconSelector from '../icons';

export const tipoSocio = [
    {
        value: null,
        label: 'Sin definir',
        description: 'No se ha definido un tipo',
        icon: IconSelector.NotDefinedIcon,
        color: 'Black'
    },
    {
        value: 'Aficionado',
        label: 'Aficionado',
        description: 'Socio Normal',
        icon: IconSelector.AmateurIcon,
        color: 'Orange'
    },
    {
        value: 'Profesional',
        label: 'Profesional',
        description: 'Socio considerado como profesional',
        icon: IconSelector.ProfesionalIcon,
        color: 'Blue'
    },
    {
        value: 'Joven',
        label: 'Joven',
        description: 'Incorporacion de Joven',
        icon: IconSelector.NewIcon,
        color: 'Green'
    }
];
